import React from 'react';
import { NavLink } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

function BackToLoginLink(): React.ReactElement {
  return (
    <NavLink
      to='/login'
      className='flex items-center gap-[7px] text-[13.5px] font-bold text-auth-mist hover:text-white'
    >
      <ArrowLeft className='h-3.5 w-3.5' aria-hidden />
      Back to login
    </NavLink>
  );
}

export default BackToLoginLink;
